import React, { useRef, useState } from "react";
import { useLanguage } from "../../hooks/useLanguage";
import "./contact-style.scss";
import emailjs from "@emailjs/browser";
import Swal from 'sweetalert2'
// Eliminamos FadeIn

export const Contact = () => {
  const { translations: t } = useLanguage();
  const CONTACT = t.contact;
  const FORM_DATA = CONTACT.gmail;
  const FORM_INFO = CONTACT.info;

  const [name, setName] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [number, setNumber] = useState<string>("");
  const [message, setMessage] = useState<string>("");

  const FORM = useRef<HTMLFormElement>(null);
  const SERVICE_ID = "service_jmrx9rp";
  const TEMPLATE_ID = "template_rx05zaa";
  const PUBLIC_KEY = "vGInZFuKaMkMkBIGr";

  const sendEmail = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!FORM.current) return;
    emailjs
      .sendForm(SERVICE_ID, TEMPLATE_ID, FORM.current, {
        publicKey: PUBLIC_KEY,
      })
      .then(
        () => {
          Swal.fire({
            title: "¡Mensaje Enviado!",
            text: "Me pondré en contacto contigo pronto.",
            icon: "success",
            background: "#1E122B",
            color: "#fff",
            confirmButtonColor: "#9333EA",
            timer: 2000,
            showConfirmButton: false
          });
          setName("");
          setEmail("")
          setNumber("")
          setMessage("")
        },
        (error) => {
          console.log("FAILED", error.text);
          Swal.fire({
            title: "Error",
            text: "Hubo un problema al enviar el mensaje.",
            icon: "error",
            background: "#1E122B",
            color: "#fff"
          });
        }
      );
  };
  
  return (
    <div className="contact_container" id="contact">
      <div className="contact_wrapper">
        <div className="header_section">
          <h2 className="section_title">
            <span className="accent_line"></span>
            {CONTACT.title}
          </h2>
          <p className="section_description" dangerouslySetInnerHTML={{__html: CONTACT.description}} />
        </div>

        <div className="content_grid">
          <div className="info_card_wrapper">
            <div className="info_card">
              <h3 className="card_title">{CONTACT.title_info}</h3>
              <div className="contact_methods">
                {FORM_INFO.map((info, id) => (
                  <div className="method_item" key={id}>
                     <div className="method_content" dangerouslySetInnerHTML={{__html: info.data}} />
                  </div>
                ))}
              </div>
              
              <div className="decorative_circle"></div>
            </div>
          </div>

          <div className="form_card_wrapper">
            <div className="form_card">
              {FORM_DATA.map((text, id) => (
                <form ref={FORM} key={id} className="modern_form" onSubmit={sendEmail}>
                  <div className="input_group">
                    <input
                      id="name"
                      type="text"
                      name="user_name"
                      className="form_input"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                      placeholder=" "
                    />
                    <label htmlFor="name" className="form_label">{text.name}</label>
                  </div>

                  <div className="input_group">
                    <input
                      id="email"
                      type="email"
                      name="user_email"
                      className="form_input"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      placeholder=" "
                    />
                    <label htmlFor="email" className="form_label">{text.email}</label>
                  </div>

                  <div className="input_group">
                    <input
                      id="number"
                      type="number"
                      name="user_number"
                      className="form_input"
                      value={number}
                      onChange={(e) => setNumber((e.target.value))}
                      required
                      placeholder=" "
                    />
                    <label htmlFor="number" className="form_label">{text.number}</label>
                  </div>

                  <div className="input_group textarea_group">
                    <textarea
                      id="message"
                      name="user_message"
                      className="form_input"
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                      required
                      placeholder=" "
                    />
                    <label htmlFor="message" className="form_label">{text.message}</label>
                  </div>

                  <button className="submit_btn" type="submit">
                    <span>{CONTACT.send}</span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="22" y1="2" x2="11" y2="13"></line>
                      <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                    </svg>
                  </button>
                </form>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
